export default __webpack_public_path__ + "upload/2.a4a0c6ea.png";